import ServiceCard from "./ServiceCard";
import styles from "./ServiciosSociales.module.css";

const ServiciosSociales = ({ servicios }) => {
  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        <ServiceCard
          title="Banco de Sangre"
          type="bancoSangre"
          data={servicios?.bancoSangre}
        />
        <ServiceCard
          title="Servicio de Sepelio"
          type="sepelio"
          data={servicios?.sepelio}
        />
        <ServiceCard
          title="Subsidio por Fallecimiento"
          type="subsidioFallecimiento"
          data={servicios?.subsFallecimiento}
        />
      </div>
    </div>
  );
};

export default ServiciosSociales;
